import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSlicePhoneFill = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-phone-fill")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_3894_210" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3894_210)">
  <path d="M18.9122 19.8846C17.1724 19.8846 15.4163 19.4407 13.6439 18.5529C11.8715 17.6651 10.2747 16.5106 8.85349 15.0894C7.43234 13.6683 6.27465 12.0747 5.38041 10.3087C4.48618 8.54263 4.03906 6.78975 4.03906 5.05C4.03906 4.75 4.13906 4.5 4.33906 4.3C4.53906 4.1 4.78906 4 5.08906 4H7.56216C7.84678 4 8.09036 4.08462 8.29291 4.25385C8.49548 4.42307 8.62625 4.64357 8.68524 4.91537L9.18139 7.3C9.22754 7.55897 9.22337 7.7939 9.16889 8.0048C9.1144 8.2157 8.99934 8.39615 8.82369 8.54615L6.65446 10.5923C7.53395 12.0744 8.53715 13.3724 9.66406 14.4865C10.791 15.6006 12.1032 16.5795 13.6006 17.4231L15.7198 15.2269C15.8955 15.0513 16.0849 14.9324 16.2881 14.8702C16.4913 14.808 16.7096 14.8 16.9429 14.8462L19.0468 15.2769C19.3186 15.3397 19.5391 15.4715 19.7083 15.6721C19.8775 15.8728 19.9622 16.1154 19.9622 16.4V18.8346C19.9622 19.1346 19.8622 19.3846 19.6622 19.5846C19.4622 19.7846 19.2122 19.8846 18.9122 19.8846Z" fill="#403CAB"/>
  </g>
  </IconWrapper>
)
